import type { RedesPublicas } from '../../api/types';

/**
 * Redes oficiais. Quem manda é Configurações › Redes no console (vem no estado da landing); estes são só o
 * padrão para um servidor que ainda não manda `redes`.
 */
export const REDES_PADRAO: RedesPublicas = {
  instagram: 'https://www.instagram.com/ultimaidle/',
  instagramUsuario: 'ultimaidle',
  discord: 'https://discord.gg/7mwCCQdy3M'
};

/** O que vale: o do servidor, se veio inteiro e em https; senão o padrão. */
export function redesDe(r: RedesPublicas | null | undefined): RedesPublicas {
  const ok = (u: unknown) => typeof u === 'string' && u.startsWith('https://');
  return r && ok(r.instagram) && ok(r.discord) && typeof r.instagramUsuario === 'string' ? r : REDES_PADRAO;
}

/** `?ref=` aceito como origem do pré-registro; o servidor confere de novo (OrigemDe). */
const ORIGENS = new Set(['discord', 'instagram', 'reddit', 'youtube', 'amigo', 'outro']);

export function origemDaUrl(): string | null {
  const ref = new URLSearchParams(window.location.search).get('ref');
  return ref && ORIGENS.has(ref) ? ref : null;
}
